import { render, staticRenderFns } from "./paper-file.vue?vue&type=template&id=0d227ff3&"
import script from "./paper-file.vue?vue&type=script&lang=js&"
export * from "./paper-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports